import React from 'react';
import { useNavigate } from 'react-router-dom';
import './EmptyStateDiscover.css';

const EmptyStateDiscover = ({ userGender, profileCompletion = 0 }) => {
  const navigate = useNavigate();
  const isFemale = userGender === 'FEMALE';

  if (isFemale) {
    return (
      <div className="empty-state-discover">
        <div className="empty-state-card">
          <div className="welcome-header">
            <div className="welcome-icon-wrapper">
              <svg className="welcome-icon" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2>Welcome to KwikLuv!</h2>
            <p className="empty-state-subtitle">
              You're all set up. Here's what you can do next:
            </p>
          </div>

          <div className="empty-state-actions">
            <div className="action-card" onClick={() => navigate('/profile')}>
              <div className="action-icon-wrapper">
                <svg className="action-svg" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                  <path d="M21 15L16 10L5 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="action-content">
                <h3>Complete Your Profile</h3>
                <p>Add more photos and details to attract the right people</p>
                {profileCompletion < 100 && (
                  <div className="action-progress">
                    <div className="progress-bar-small">
                      <div 
                        className="progress-fill-small" 
                        style={{ width: `${profileCompletion}%` }}
                      />
                    </div>
                    <span>{profileCompletion}% complete</span>
                  </div>
                )}
              </div>
              <svg className="arrow-icon" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            {/* "Become a Creator" action card removed - creator mode disabled in UI */}

            <div className="action-card" onClick={() => navigate('/inbox')}>
              <div className="action-icon-wrapper inbox">
                <svg className="action-svg" viewBox="0 0 24 24" fill="none">
                  <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H5C4.46957 17 3.96086 16.7893 3.58579 16.4142C3.21071 16.0391 3 15.5304 3 15V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H19C19.5304 6 20.0391 6.21071 20.4142 6.58579C20.7893 6.96086 21 7.46957 21 8V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 8L12 13L21 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="action-content">
                <h3>Check Your Inbox</h3>
                <p>See if anyone has sent you a message</p>
              </div>
              <svg className="arrow-icon" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            <div className="action-card" onClick={() => navigate('/profile')}>
              <div className="action-icon-wrapper video">
                <svg className="action-svg" viewBox="0 0 24 24" fill="none">
                  <rect x="2" y="6" width="20" height="12" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <path d="M22 8.5L17 12L22 15.5V8.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="action-content">
                <h3>Enable Video Calls</h3>
                <p>Set your rate and earn credits from video calls</p>
                <button 
                  className="btn-enable-calls"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/profile');
                  }}
                >
                  Set Up Now
                </button>
              </div>
              <svg className="arrow-icon" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>

          <div className="empty-state-info">
            <div className="info-box">
              <svg className="info-icon-svg" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <div>
                <p className="info-title">How it works</p>
                <p className="info-text">
                  Men will browse profiles and send you messages. You decide who to respond to. You're in complete control!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Male users - different empty state
  return (
    <div className="empty-state-discover">
      <div className="empty-state-card">
        <div className="welcome-header">
          <div className="welcome-icon-wrapper">
            <svg className="welcome-icon" viewBox="0 0 24 24" fill="none">
              <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
              <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <h2>No Profiles Available Yet</h2>
          <p className="empty-state-subtitle">
            We're growing! Check back soon for new members in your area.
          </p>
        </div>

        <div className="empty-state-actions">
          <div className="action-card" onClick={() => navigate('/profile')}>
            <div className="action-icon-wrapper">
              <svg className="action-svg" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                <path d="M21 15L16 10L5 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="action-content">
              <h3>Complete Your Profile</h3>
              <p>Add photos and details to make a great first impression</p>
              {profileCompletion < 100 && (
                <div className="action-progress">
                  <div className="progress-bar-small">
                    <div 
                      className="progress-fill-small" 
                      style={{ width: `${profileCompletion}%` }}
                    />
                  </div>
                  <span>{profileCompletion}% complete</span>
                </div>
              )}
            </div>
            <svg className="arrow-icon" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          {/* PHASE 1: Buy Credits disabled - messaging is free */}
          {false && (
          <div className="action-card" onClick={() => navigate('/buy-credits')}>
            <div className="action-icon-wrapper creator">
              <svg className="action-svg" viewBox="0 0 24 24" fill="none">
                <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 9V15M9 12H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="action-content">
              <h3>Buy Credits</h3>
              <p>Get credits to send messages and unlock features</p>
            </div>
            <svg className="arrow-icon" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          )}
        </div>

        <div className="empty-state-info">
          <div className="info-box">
            <svg className="info-icon-svg" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <div>
              <p className="info-title">New members join daily</p>
              <p className="info-text">
                Enable notifications to know when new profiles are available in your area!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyStateDiscover;
